import { render, staticRenderFns } from "./inputThumbnail.vue?vue&type=template&id=ace95640"
import script from "./inputThumbnail.vue?vue&type=script&lang=js"
export * from "./inputThumbnail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports